<template>
	<div class="app-select">
		<v-select class="naked" v-bind="$attrs" v-on="$listeners" v-if="naked" solo flat :hide-details="hideDetails" ref="select">
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope" />
			</template>
			<template v-for="(index, name) in $slots" v-slot:[name]>
				<slot :name="name" />
			</template>
		</v-select>
		<v-select v-else v-bind="$attrs" v-on="$listeners" :hide-details="hideDetails" ref="select">
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope" />
			</template>
			<template v-for="(index, name) in $slots" v-slot:[name]>
				<slot :name="name" />
			</template>
		</v-select>
	</div>
</template>

<script>
import AtomsMixins from '../common/atoms.mixin';
export default {
	name: 'AppSelect',
	mixins: [AtomsMixins],
	props: {
		naked: { type: Boolean },
	},
	methods: {
		blur() {
			this.$refs.select.blur();
		},
	},
};
</script>

<style scoped lang="scss">
.app-select {
	.naked {
		border-style: none !important;
	}

	::v-deep {
		.v-input {
			fieldset {
				border: var(--primary-border);
				border-radius: var(--input-border-radius);
			}
			.v-icon {
				&::before {
					content: '\f107';
					color: rgb(154 159 168);
					font-size: 18px;
				}
			}
			.v-input__control {
				border-radius: var(--input-border-radius);
			}
		}
		.v-divider {
			margin: 10px;
			padding: 10px;
		}

		.v-text-field--outlined {
			.v-input__append-inner {
				margin-top: 8px !important;
			}
		}
	}
}
</style>

<style lang="scss">
// This is globally dangling CSS which is far from idel and an opening for bugs
.v-menu__content {
	hr.v-divider {
		margin: 3px 5px;
	}
}
</style>
